import React, { useState } from "react";
import { TextDates, TextUsername, WrapperContent } from "./index.style";
import HeaderContent from "./HeaderContent/HeaderContent";
import {
    AddIcon,
    Avatar,
    Button,
    CloseIcon,
    Dialog,
    Divider,
    Flex,
    Loader,
    SplitButton,
    Text,
} from "@fluentui/react-northstar";
import {
    ArrowRepeatAll20Regular,
    CalendarInfo20Regular,
    Clock20Regular,
    Home20Regular,
} from "@fluentui/react-icons";
import DialogDeclareRemoteDay from "../DialogDeclareRemoteDay/DialogDeclareRemoteDay";
import useLogicRemotePopupContent from "../../hooks/useLogicRemotePopupContent";
import styled from "styled-components";
import moment from "moment";

/**
 * @typedef {Object} Dates
 * @property {string} start
 * @property {string} end
 *
 * @typedef {Object} Times
 * @property {string} start
 * @property {string} end
 *
 *
 * @typedef {Object} PropsType
 * @property {number} event_id - id de l'event
 * @property {{ icon: React.JSX, content : string, reason_id : number | null }} title
 * @property {{ name: string, avatar : string }} user
 * @property {Dates} dates
 * @property {Times} times
 * @property {boolean} can_update_or_delete - show or not buttons actions
 *
 * @param {PropsType} Props
 * @returns
 */
const PopupContent = ({
    closePopup = () => null,
    event_id,
    title,
    user,
    dates,
    times,
    can_update_or_delete,
    reason,
    series,
    repeat,
    until_date,
}) => {
    const { strings, mutate, query } = useLogicRemotePopupContent({
        event_id,
        dates,
        times,
    });
    const [confirmdelete, setConfirmDelete] = useState(false);
    const [openDialog, setOpen] = useState(false);
    const [eventType, setEventType] = useState({
        actualEvent: false,
        serieEvent: false,
    });

    const [menuOpenUpdate, setMenuOpenUpdate] = useState(false);
    const [menuOpenDelete, setMenuOpenDelete] = useState(false);

    // here
    const [dialogHeader, setDialogHeader] = useState("");
    const [dialogDescription, setDialogDescription] = useState("");

    // here
    const handleMenuClick = (key) => {
        if (key === 1) {
            setEventType({ actualEvent: true, serieEvent: false });

            return setOpen(true); // Ouvre le Dialog
        } else if (key === 2) {
            setEventType({ actualEvent: false, serieEvent: true });

            return setOpen(true); // Ouvre le Dialog
        }
        setMenuOpenUpdate(false); // Ferme le menu après action
    };

    const handleDeleteSerieClick = (key) => {
        setDialogHeader(
            "Êtes-vous sûr.e de vouloir supprimer les évènements de la série ?"
        );
        setDialogDescription("Ils ne seront plus visibles dans le calendrier.");
        setConfirmDelete(true);
        setEventType({ actualEvent: false, serieEvent: true });
    };

    const handleDeleteEventClick = (key) => {
        setDialogHeader("Êtes-vous sûr.e de vouloir supprimer l'évènement");
        setDialogDescription("Il ne sera plus visible dans le calendrier.");
        setConfirmDelete(true);
        setEventType({ actualEvent: true, serieEvent: false });
    };

    const handleMainClickDelete = (e) => {
        e.stopPropagation(); // Empêche le clic de remonter au Dialog
        e.preventDefault(); // Empêche le submit si dans un formulaire
        setMenuOpenDelete(!menuOpenDelete);
    };
    const handleMainClickUpdate = (e) => {
        e.stopPropagation(); // Empêche le clic de remonter au Dialog
        e.preventDefault(); // Empêche le submit si dans un formulaire
        setMenuOpenUpdate(!menuOpenUpdate);
    };

    const getRepeatContent = (repeat) => {
        switch (repeat) {
            case 0:
                return "Ne pas répéter";
            case 1:
                return "Chaque Semaine";
            case 2:
                return "Chaque deux semaines";
            case 3:
                return "Chaque trois semaines";
            case 4:
                return "Chaque quatres semaines";
            case null:
                return "Ne pas répéter";
            default:
                return "Ne pas répéter";
        }
    };

    return (
        <Flex>
            <Dialog
                styles={{ width: "700px" }}
                open={confirmdelete}
                content={dialogDescription}
                header={<Text content={`${dialogHeader}`} />}
                cancelButton="Annuler"
                confirmButton={{
                    flat: true,
                    content: "Supprimer",
                    styles: {
                        backgroundColor: "#C4314B",
                    },
                    loading: mutate.isLoading,
                    disabled: mutate.isLoading,
                }}
                onConfirm={() => {
                    eventType.actualEvent && mutate.handleClickDelete(event_id);
                    eventType.serieEvent &&
                        series &&
                        mutate.handleClickDelete(series);
                }}
                headerAction={{
                    icon: <CloseIcon />,
                    title: "Fermer",
                    onClick: () => {
                        setConfirmDelete(false);
                        setMenuOpenDelete(false);
                    },
                }}
                onCancel={() => {
                    setConfirmDelete(false);
                    setMenuOpenDelete(false);
                }}
            />
            <WrapperContent
                style={{ margin: "-16px" }}
                // ! class obligatoire ne pas retirer
                className="popup"
                column
                data-event-id={event_id}
                onClick={(e) => {
                    console.log("click popup content");
                    // e.preventDefault();
                    // e.stopPropagation();
                }}
            >
                {/* header */}
                <HeaderContent
                    setMenuOpenDelete={setMenuOpenDelete}
                    setMenuOpenUpdate={setMenuOpenUpdate}
                    closePopup={closePopup}
                    content={title.content}
                    icon={title.icon}
                    user={user}
                />
                {/* body */}
                <Flex
                    styles={{ marginTop: "16px", paddingInline: "16px" }}
                    column
                >
                    <Flex column gap="gap.small">
                        <Flex fill gap="gap.smaller" vAlign="center">
                            <Home20Regular color="#5B5FC7" />
                            <TextStyle content={reason} />
                        </Flex>
                        <Divider />
                        <Flex fill gap="gap.smaller" vAlign="center">
                            <Clock20Regular color="#5B5FC7" />
                            <TextStyle
                                styles={{ textTransform: "capitalize" }}
                                content={` ${moment(dates?.start).format(
                                    " dddd DD/MM/YYYY"
                                )} (Toute la journée)`}
                            />
                        </Flex>
                        <Divider />
                        <Flex fill gap="gap.smaller" vAlign="center">
                            <ArrowRepeatAll20Regular color="#5B5FC7" />
                            <TextStyle content={getRepeatContent(repeat)} />
                        </Flex>
                        <Divider />
                    </Flex>
                    {/* buttons */}
                    {can_update_or_delete && (
                        <Flex
                            fill
                            gap="gap.smaller"
                            hAlign="end"
                            styles={{ marginTop: "32px" }}
                        >
                            {/* delete telework here */}
                            <SplitButton
                                secondary
                                open={menuOpenDelete}
                                onMenuOpenChange={(_, data) =>
                                    setMenuOpenDelete(data.menuOpen)
                                }
                                flat
                                menu={[
                                    {
                                        key: 1,
                                        content: "Cet évènement",
                                        onClick: () =>
                                            handleDeleteEventClick(event_id),
                                        // disabled: series ? true : false,
                                    },
                                    {
                                        key: 2,
                                        content:
                                            "Cet évènement et tous les autres de la série",
                                        onClick: () =>
                                            handleDeleteSerieClick(series),
                                        disabled: series ? false : true,
                                    },
                                ]}
                                button={{
                                    content: "Supprimer",
                                    flat: true,
                                }}
                                toggleButton={{
                                    "aria-label": "plus d’options",
                                    onClick: handleMainClickDelete, // <- Et aussi ici pour l’icône
                                }}
                                onMainButtonClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    setMenuOpenDelete(!menuOpenDelete);
                                }}
                            />
                            {/* delete telework here */}

                            {/* update telework here  */}
                            <SplitButton
                                primary
                                open={menuOpenUpdate}
                                onMenuOpenChange={(_, data) =>
                                    setMenuOpenUpdate(data.menuOpen)
                                }
                                flat
                                menu={[
                                    {
                                        key: 1,
                                        content: "Cet évènement",
                                        onClick: (e) => {
                                            handleMenuClick(1);
                                        },
                                        // disabled: series ? true : false,
                                    },
                                    {
                                        key: 2,
                                        content:
                                            "Cet évènement et tous les autres de la série",
                                        onClick: () => handleMenuClick(2),
                                        disabled: series ? false : true,
                                    },
                                ]}
                                button={{
                                    content: "Modifier",
                                    flat: true,
                                }}
                                toggleButton={{
                                    "aria-label": "plus d’options",
                                    onClick: handleMainClickUpdate, // <- Et aussi ici pour l’icône
                                }}
                                onMainButtonClick={(e) => {
                                    // e.stopPropagation();
                                    // e.preventDefault();
                                    setMenuOpenUpdate(!menuOpenUpdate);
                                }}
                            />
                            {/* update telework here  */}

                            <DialogDeclareRemoteDay
                                EditEvent={true}
                                eventType={eventType}
                                open={openDialog}
                                isForUpdatingDay={true}
                                updateData={{
                                    start_date: query?.data?.start?.date,
                                    start_time: query?.data?.start?.time,
                                    end_date: query?.data?.end?.date,
                                    end_time: query?.data?.end?.time,
                                    reason: query?.data?.reason?.value,
                                }}
                                event_id={event_id}
                                onClose={() => {
                                    setMenuOpenUpdate(!menuOpenUpdate);
                                    setOpen(false);
                                    return query.refetch();
                                }}
                                series={series}
                                repeat={repeat}
                                until_date={query?.data?.until_date}
                            />
                        </Flex>
                    )}
                </Flex>
            </WrapperContent>
        </Flex>
    );
};

export default PopupContent;

const TextStyle = styled(Text)`
    color: #242424;
    font-family: "Segoe UI";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
`;
